"use client";
import { useReducer } from "react";
import React from "react";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
import BookingContext from "./bookingContext";
import BookingReducer from "./bookingReducer";
import { PaymentMethodVm } from "@/model";
import { BookingInfo } from "@/types/components";

const BookingState: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const initialState = {
    bookingInfo: {}, //info saved globally in order to change route and have the values available
    loading: false,
    paymentState: {},
    bookingInfoAfterPurchase: {},
  };

  const [state, dispatch] = useReducer(BookingReducer, initialState);
  const [cookies, setCookie, removeCookie] = useCookies();

  const saveBookingInfo = (data: BookingInfo): void => {
    //borrar anteriores reservas

    Object.keys(cookies).forEach((cookie: string) => {
      if (cookie.length == 4 || cookie.length == 5) {
        if (cookies[cookie].booking_payload) {
          setCookie(cookie, "", {
            path: "/",
            expires: new Date("01/01/2024"),
          });
        }
      }
    });
    if (cookies[data.id]) {
      removeCookie(data.id);
      setCookie(data.id, data, {
        expires: data.expire_date,
        path: "/",
      });
    } else {
      setCookie(data.id, data, {
        expires: data.expire_date,
        path: "/",
      });
    }
    dispatch({
      type: "SAVE_BOOKING",
      payload: data,
    });
  };

  const savePaymentInfo = (data: any) => {
    //for fiscal-data form
    dispatch({
      type: "SAVE_PAYMENT",
      payload: data,
    });
  };

  const saveBookingInfoAfterPurchase = (
    bookingInfo: BookingInfo,
    mail: string,
    mobile: string,
    totalPrice: number,
    paymentInfo: PaymentMethodVm,
    veeFee: string,
    subtotal: string,
    percentOff?: number,
  ) => {
    const auxObject = {
      bookingInfo: bookingInfo,
      mail: mail,
      mobile: mobile,
      totalPrice: totalPrice,
      paymentInfo: paymentInfo,
      veeFee: veeFee,
      subtotal: subtotal,
      percentOff: percentOff ?? null,
    };
    dispatch({
      type: "SAVE_INFO_AFTER_PURCHASE",
      payload: auxObject,
    });
  };
  return (
    <BookingContext.Provider
      value={{
        loading: state.loading,
        saveBookingInfo,
        savePaymentInfo,
        bookingInfo: state.bookingInfo,
        paymentState: state.paymentState,
        bookingInfoAfterPurchase: state.bookingInfoAfterPurchase,
        saveBookingInfoAfterPurchase,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

BookingState.propTypes = {
  children: PropTypes.any,
};

export default BookingState;
